// extracted by mini-css-extract-plugin
export default {"paymentGuide":"PaymentGuide_paymentGuide__Bhzm3","title":"PaymentGuide_title__eZhaq","iconWrapper":"PaymentGuide_iconWrapper__fq43P"};